export const ds_RichTextBlock_Entry = `
    fragment ds_RichTextBlock_Entry on ds_RichTextBlock_Entry {
        id
        canonicalUid

        richText_ColorPalette
        richText_ColorTheme
        richText_ContainerWidth
        richText_FullWidthBackground
        richText_TopSpacing

        richText_Text
        richText_ButtonAlignment
        richText_Buttons {
            target
            title
            text
            url
            ... on richText_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Email_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Phone_LinkType {
                buttonStyle
            }
        }
    }
`
